var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.step == "form"
      ? _c("div", [
          _c("form", { staticClass: "theory__form" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { "has-error": _vm.errors.name },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contact.name,
                          expression: "contact.name",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Ваше имя" },
                      domProps: { value: _vm.contact.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.contact, "name", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.name
                      ? _c("p", { staticClass: "help-block" }, [
                          _vm._v(_vm._s(_vm.errors.name.join(", ")) + " "),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { "has-error": _vm.errors.phone },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contact.phone,
                          expression: "contact.phone",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "email",
                        placeholder: "E-mail для отправки",
                      },
                      domProps: { value: _vm.contact.phone },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.contact, "phone", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.phone
                      ? _c("p", { staticClass: "help-block" }, [
                          _vm._v(_vm._s(_vm.errors.phone.join(", "))),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-error": _vm.errors.message },
              },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.message,
                      expression: "contact.message",
                    },
                  ],
                  staticClass: "form-control theory__textarea",
                  attrs: {
                    placeholder:
                      "Комментарий (расскажите о ваших целях, опыте и проблемах со здоровьем)",
                  },
                  domProps: { value: _vm.contact.message },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.contact, "message", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.message
                  ? _c("p", { staticClass: "help-block" }, [
                      _vm._v(_vm._s(_vm.errors.message.join(", ")) + " "),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-bottom theory__form-bottom" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success form-bottom__btn",
                  attrs: { type: "button" },
                  on: { click: _vm.sendForm },
                },
                [_vm._v("Отправить")]
              ),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step == "complete"
      ? _c("div", [
          _c("p", { staticClass: "text-success" }, [
            _vm._v(
              "\n    Ваше сообщение успешно отправлено! Я свяжусь с Вами в ближайшее время. "
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-bottom__text" }, [
      _vm._v("\n          Отправляя сообщение, вы принимаете "),
      _c("a", { attrs: { href: "/pages/politika-konfidencialnosti/" } }, [
        _vm._v("условия обработки"),
      ]),
      _vm._v(" персональных данных\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }